<template>
<v-card flat>
  <v-window v-model="step" vertical >
    <v-window-item >
      <v-card>
        <v-card-text class='text-h5 font-weight-light my-5 text-center' >
          You can add one or more locations to your space. <br/>
          A location can be physical or virtual. <br/>
          You can assign your appointment types to your locations and define custom operating hours for each location.
        </v-card-text>
        <v-card-title >
          <v-spacer/>
          <v-btn large @click='step++' class='mb-5' color="primary" >Got it!</v-btn>
          <v-spacer/>
        </v-card-title>
      </v-card>
    </v-window-item >

    <v-window-item>
      <v-card v-if="!editMode"
        class='ma-sm-2 grey lighten-2' >
        <v-card-title class="grey overline py-0" >
          Add a new location
        </v-card-title>
        <v-divider/>
        <v-card-text >
          <v-subheader class='overline pl-2' >Find your location in Google Maps</v-subheader>
          <address-picker
            v-model='place'
            :search.sync="placesearch"
            api-key='AIzaSyDBLqBJhup-u2afKcqqonWzGC-vv_7YpnY' />
        </v-card-text>
        <v-card-actions >
          <v-spacer/>
          <v-btn small class="primary"
            :disabled="req.loading"
            @click="create(placesearch)" >Manually create location</v-btn>
        </v-card-actions>
        <!-- <pre v-text="place" class="caption pa-2 grey lighten-4" /> -->
      </v-card>

      <v-card outlined v-else >
        <v-card-title v-if='edit' >
          {{ selectedLocation.name }}
          <v-spacer/>
          <v-btn icon small
            @click='newLocation' >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text transition="slide-y-transition" >
          <request-status :request="req" />
          <v-text-field filled autofocus persistent-hint
            v-model='selectedLocation.name'
            label='Address name' />

          <v-text-field filled autofocus persistent-hint
            v-model='selectedLocation.address'
            label='Address' />

          <div >
            <v-text-field filled clearable persistent-hint
              label="Preferred map URL"
              hint="Your preferred map link to share. Leave blank for AppointmentGuru to autogenerate a link based on latitude and longitude and a Google place"
              v-model="selectedLocation.preferred_map_url" ></v-text-field>

            <v-chip small
              v-if="preferredLink"
              :href="preferredLink"
              target="_blank" >
              <strong>Map Link:</strong> {{preferredLink}}
              <v-icon right small >mdi-open-in-new</v-icon>
            </v-chip>
          </div>

          <v-row >
            <v-col cols=12 sm=6 >
              <v-text-field filled autofocus persistent-hint
                v-model='selectedLocation.latitude'
                label='Latitude' />
            </v-col>
            <v-col cols=12 sm=6 >
              <v-text-field filled autofocus persistent-hint
                v-model='selectedLocation.longitude'
                label='Longitude' />
            </v-col>
          </v-row>

          <v-textarea v-model="selectedLocation.notes" filled
            rows="2"
            label="Additional notes"
            hint="Provide some extra information to help your client find you once they've arrived at the address" />

          <v-card-actions >
            <v-btn
              v-if='selectedLocation.id'
              @click='deleteLocation(selectedLocation)' color='error' >Delete</v-btn>
            <v-spacer/>
            <v-btn @click="save" color="primary" :loading='req.loading' >Save</v-btn>
            <v-btn text @click="save();$emit('next')" color="primary" >Save and next</v-btn>
          </v-card-actions>

        </v-card-text>
      </v-card>

      <v-card class="mt-10 elevation-10 mx-2" >
        <!-- L:{{loading}} | {{req.loading}} | {{delReq.loading}} -->
        <v-overlay absolute :value='loading' >
          <v-progress-circular indeterminate color="amber" width="2" :opacity='0.1' />
        </v-overlay>

        <v-card-title class="overline grey lighten-2 py-0" >Locations</v-card-title>

        <v-btn fab absolute top right small
          color='primary'
          @click='newLocation' >
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-data-table dense hide-default-footer
          no-data-text="None created yet"
          :items='locations'
          :headers='headers'
          :loading="getReq.loading"
          @click:row='editRow' >
          <template v-slot:item.delete="{ item }" >
            <!-- <v-icon>mdi-trash</v-icon> -->
            <v-btn x-small icon
              @click.stop='deleteLocation(item)'
              :loading="delReq.loading"
              color='error' ><v-icon>mdi-delete</v-icon></v-btn>

          </template>
          <template v-slot:item.preview="{ item }" >
            <v-btn x-small icon @click="preview(item)"
              color='info' ><v-icon>mdi-eye</v-icon></v-btn>
          </template>
        </v-data-table>

      </v-card>

      <!-- <v-btn @click='get' class='mt-4' /> -->
      <v-divider class='mt-5' />
      <v-card-actions >
        <v-btn @click='$emit("back")' text >Back</v-btn>
        <v-spacer/>
        <v-btn @click='$emit("next")' :disabled='numLocations < 1' color="primary" >
          Next
        </v-btn>
      </v-card-actions>
    </v-window-item>
  </v-window>
  <!-- place: <pre v-text="place" /> -->
  <v-dialog width="500" v-model="previewdialog" >
    <v-card v-if="previewLocation && previewLocation.id" >
      <v-card-title class="overline py-0 grey darken-4 white--text" >
        {{previewLocation.name}}
        <v-spacer/>
        <v-btn dark @click="previewdialog=false" icon small ><v-icon small >mdi-close</v-icon></v-btn>
      </v-card-title>
      <location-card v-model="previewLocation" />
    </v-card>
  </v-dialog>
</v-card>
</template>
<script>
import AddressPicker from '@/components/pickers/AddressPicker.vue'
import LocationCard from '@/components/cards/LocationCard.vue'
export default {
  name: 'Locations',
  components: { AddressPicker, LocationCard },
  props: {
    spaceId: { required: true }
  },
  data () {
    return {
      getReq: { resource: 'ag.spaces', extra: 'addresses' },
      req: { resource: 'ag.spaces', extra: 'addresses' },
      delReq: { resource: 'ag.spaces', extra: 'addresses' },
      selectedLocation: {},
      previewLocation: {},
      edit: false,
      step: 0,
      placesearch: '',
      place: {},
      previewdialog: false,
      headers: [
        { text: '', value: 'delete' },
        { text: 'Name', value: 'name' },
        // { text: 'Address', value: 'address' },
        { text: 'Latitude', value: 'latitude' },
        { text: 'Longitude', value: 'longitude' },
        { text: '', value: 'preview' },
      ]
    }
  },
  methods: {
    preview (loc) {
      this.previewLocation = loc
      this.previewdialog = true
    },
    get () {
      this.getReq.resourceId = this.spaceId
      this.$request('get', this.getReq)
    },
    editRow (row) {
      this.selectedLocation = row
      this.edit = true
    },
    create (name) {
      let data = {name}
      if (!name) {
        data = JSON.parse(JSON.stringify(this.selectedLocation))
      }
      this.safelyRemoveKey(data, 'id')
      this.req.data = data
      this.req.extra = 'addresses'
      this.req.resourceId = this.spaceId
      this.req.method = 'post'
      this.$request('save', this.req)
    },
    save () {
      this.req.data = this.selectedLocation
      if (this.selectedLocation && this.selectedLocation.id && this.selectedLocation.name) {
        this.req.data.practitioner = this.meId
        this.req.resourceId = this.spaceId
        this.req.method = 'patch'
        this.req.extra = 'addresses/' + this.selectedLocation.id
        this.$request('save', this.req)
      }
    },
    deleteLocation (location) {
      if (location && location.id) {
        this.delReq.resourceId = this.spaceId
        this.delReq.extra = 'addresses/' + location.id
        this.$request('delete', this.delReq)
      } else {
        console.error('No location ID ', location)
      }
    },
    newLocation () {
      this.place = {}
      this.selectedLocation = {}
      this.edit = false
    }
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        if (this.spaceId) {
          this.get()
        }
      }
    },
    placeId () {
      if (this.placeId) {
        // this.selectedLocation.id = null
        console.log(this.place)
        this.selectedLocation.name = this.place.name
        this.selectedLocation.address = this.place.formatted_address
        this.selectedLocation.latitude = this.getObjectPath(this.place, 'geometry.location.lat')()
        this.selectedLocation.longitude = this.getObjectPath(this.place, 'geometry.location.lng')()
        this.selectedLocation.place_id = this.placeId
        this.selectedLocation.place_data = this.place
        this.create()
      }
    },
    reqStatus () {
      if (this.reqStatus === 201) {
        this.selectedLocation = this.req.result
        this.get()
      }
      if (this.reqStatus === 200) {
        this.selectedLocation = this.req.result
        this.get()
      }
    },
    delReqStatus () {
      if (this.delReqStatus === 204) { this.get() }
    }
  },
  computed: {
    locations () {
      return this.getObjectPath(this.getReq, 'result.results', [])
    },
    preferredLink () {
      let computedLink = this.getObjectPath(this.selectedLocation, 'map_link')
      return this.getObjectPath(this.selectedLocation, 'preferred_map_url', computedLink)
    },
    editMode () {
      if (this.selectedLocation && this.selectedLocation.id) { return true }
      return false
    },
    getReqStatus () { return this.getReq.status },
    delReqStatus () { return this.delReq.status },
    reqStatus () { return this.req.status },
    loading () { return (this.req.loading === true) || (this.delReq.loading === true) || (this.getReq.loading === true) },
    placeId () { return this.getObjectPath(this.place, 'place_id') },
    numLocations () { return this.locations.length }
  }
}
</script>
